import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, CurrentUserResponse } from '@core/api/auth/auth.service';
import { catchError, map, of } from 'rxjs';

export const newUserGuard: CanActivateFn = (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // Helper function to check if user should access new user routes
    const checkNewUserAccess = (userData: any): boolean => {
        if (userData?.is_new) {
            return true;
        } else {
            router.navigate(['/home'], { replaceUrl: true });
            return false;
        }
    };

    // Helper function to handle authentication failure
    const handleAuthFailure = () => {
        auth.clearUser();
        router.navigate(['/login'], { replaceUrl: true });
        return of(false);
    };

    // If user data is already cached
    if (auth.user()) {
        return of(checkNewUserAccess(auth.user()));
    }

    // Fetch user data if not cached
    return auth.getCurrentUser().pipe(
        map((response: CurrentUserResponse) => {
            if (response.data) {
                auth.setUser(response.data);
                return checkNewUserAccess(response.data);
            }
            router.navigate(['/login'], { replaceUrl: true });
            return false;
        }),
        catchError((error) => {
            console.error('Failed to fetch user data:', error);
            return handleAuthFailure();
        })
    );
};
